import React, { useState } from 'react';
import { withStyles, Button } from '@material-ui/core';
import { navigate } from 'gatsby';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useMediaQueries } from '../../hooks/useMediaQueries';

const classes = {
    button: {
        color: '#1C92D1',
        border: '1px solid #C7C7C7',
        fontWeight: 'bolder',
        paddingLeft: '10px',
        paddingRight: '10px',
    },
    buttonHover: {
        border: '1px solid #C7C7C7',
        background: '#1C92D1',
        paddingLeft: '10px',
        paddingRight: '10px',
        color: 'white',
        '&:hover': {
            backgroundColor: '#1C92D1',
        },
        fontWeight: 'bolder',
    },
    card: {
        padding: '20px 0px 20px 20px',
    },
    mobileCard: {
        paddingBottom: '3em',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    item: {
        border: '1px solid transparent',
    },
    itemHover: {
        background: '#FAFAFA',
        border: '1px solid #E1E1E1',
        cursor: 'pointer',
    },
    image: {
        'margin-bottom': '10px',
        height: '40px',
    },
    label: {
        fontFamily: 'Roboto',
        fontSize: 14,
        marginRight: 10,
        letterSpacing: '0.5px',
    },
    mobileLabel: {
        fontFamily: 'Roboto',
        fontSize: 14,
        marginRight: 10,
        letterSpacing: '0.5px',
        textAlign: 'center',
    },
};

const ProductCard = (props) => {
    const [hover, setHover] = useState(false);
    const isSmallDisplay = useMediaQueries('sm');

    const handleClick = () => {
        navigate(props.to);
    };

    const onHover = () => {
        setHover(!hover);
    };

    const { classes } = props;
    const itemClass = hover ? classes.itemHover : classes.item;
    const buttonClass = hover ? classes.buttonHover : classes.button;
    return (
        <div className={itemClass} onClick={handleClick}>
            <div
                className={!isSmallDisplay ? classes.card : classes.mobileCard}
                onMouseLeave={onHover}
                onMouseEnter={onHover}
            >
                <img
                    justify="center"
                    height="100px"
                    className={classes.image}
                    src={props.image}
                    alt={props.productName}
                />
                <p className={!isSmallDisplay ? classes.label : classes.mobileLabel}>{props.description}</p>
                <Button className={buttonClass} color="primary" onClick={handleClick}>
                    {`Browse ${props.productName} help`}
                </Button>
            </div>
        </div>
    );
};

export default withStyles(classes)(ProductCard);
